import classes from './footer.module.css'
import { Link, useLocation } from 'react-router-dom'

import MasterCard from '../../assets/images/master_card.png'
import Maestro from '../../assets/images/maestro.png'
import Visa from '../../assets/images/visa.png'
import Mir from '../../assets/images/mir.png'

import VK from '../../assets/images/vk.png'
import GP from '../../assets/images/GP.png'
import AS from '../../assets/images/appstore.svg'
import Instagram from '../../assets/images/instagram.png'
import Logo from '../../assets/images/logo.png'
import Whatsapp from '../../assets/images/whatsapp.svg'
import React, { useEffect, useRef, useState } from 'react'
import { useTypedSelector } from '../../hooks/useTypedSelector'
import { Widget } from '../widget/Widget'
import { Casino } from '../casino/Casino'
import { ImagesGame } from '../casino/ImagesGame'

const Footer = () => {
    const paths = ['/cart', '/order']
    const { cart } = useTypedSelector((state) => state.cartReducer)
    const location = useLocation()
    const [isMinicart, setMiniCart] = useState(false)
    useEffect(() => {
        if (!paths.includes(location.pathname) && cart.length !== 0) {
            setMiniCart(true)
        } else {
            setMiniCart(false)
        }
    }, [location.pathname, cart])

    return (
        <>
            {/* <Casino isMinicart={isMinicart} /> */}
            {/* <ImagesGame isMinicart={isMinicart} /> */}
            {/* <Widget isMinicart={isMinicart} /> */}
            <div className={classes.preFooter}>
                <div className={classes.inner}>
                    <ul role='navigation' className={classes.left}>
                        {links.map((l, i) => (
                            <li key={`footer_link_${i}`}>
                                <Link to={l.path}>{l.name}</Link>
                            </li>
                        ))}
                    </ul>
                    <div className={classes.center}>
                        <Link to='/'>
                            <div
                                className={classes.logoBg}
                                style={{ backgroundImage: `url('${Logo}')` }}
                            />
                        </Link>
                    </div>
                    <div className={classes.right}>
                        <h5>служба поддержки клиентов:</h5>
                        <a href='tel:+74952601003'>+7 (495) 260-10-03</a>
                        <a
                            href='https://wa.me/message/M57AZ5K4Y4NRE1'
                            className={classes.wa}
                            target='_blank'
                            rel='noopener noreferrer nofollow'>
                            <img src={Whatsapp} alt='WhatsApp' />
                            WhatsApp
                        </a>
                        <br />
                        <Link to='/documents?block=delivery'>доставка</Link>
                        <Link to='/documents?block=reqs'>реквизиты</Link>
                        <Link to='/documents?block=offer'>договор оферты</Link>
                        <Link to='/documents?block=policy'>
                            конфиденциальность и защита информации
                        </Link>
                        <Link to='/documents?block=return'>правила возврата товара</Link>
                        <Link to='/documents?block=loyalty'>о программе лояльности</Link>
                        {/*<a href="https://drive.google.com/file/d/1REtbYyO1OozFqjkrMEUg2hEuiv7uvdfo/view" target="_blank" rel="noopener noreferrer nofollow">сертификаты</a>*/}
                    </div>
                </div>
            </div>
            <footer className={`${classes.footer} ${isMinicart ? classes.footerMinicart : ''}`}>
                <div className={classes.inner}>
                    <div className={classes.social_wrapper}>
                        <div className={classes.social}>
                            {/* <a
                            href='https://instagram.com/parfumer_atelier'
                            target='_blank'
                            rel='noopener nofollow norefferer'>
                            <img src={Instagram} alt='Parfumer Atelier Instagram' />
                        </a> */}
                            <a
                                href='https://vk.com/parfumer_atelier'
                                target='_blank'
                                rel='noopener nofollow norefferer'>
                                <img src={VK} alt='Parfumer Atelier ВКонтакте' />
                            </a>
                            <a
                                href='https://play.google.com/store/apps/details?id=one.clockwork.parfum'
                                target='_blank'
                                rel='noopener nofollow norefferer'>
                                <img src={GP} alt='Parfumer Atelier Google Play' />
                            </a>
                            <a
                                href='https://apps.apple.com/ru/app/parfumer-atelier/id6463387736'
                                target='_blank'
                                rel='noopener nofollow norefferer'>
                                <img src={AS} alt='Parfumer Atelier Apple Store' />
                            </a>
                        </div>
                        <a
                            href='https://clockwork.one/?utm_source=parfumeratelier.ru'
                            target='_blank'
                            className={classes.made_by}>
                            Сделано в{' '}
                            <svg
                                version='1.1'
                                id='Layer_1'
                                xmlns='http://www.w3.org/2000/svg'
                                x='0px'
                                y='0px'
                                viewBox='0 0 1241 150'
                                fill='white'>
                                <g>
                                    <polygon points='1240.7,2.4 1200.8,2.4 1148.9,75 1200.8,147.5 1240.7,147.5 1188.7,75  ' />
                                    <path d='M916.2,0c-41.4,0-75,33.6-75,75h32.5c0-23.5,19-42.5,42.5-42.5c23.5,0,42.5,19,42.5,42.5c0,23.5-19,42.5-42.5,42.5V150   c41.4,0,75-33.6,75-75C991.2,33.6,957.7,0,916.2,0z' />
                                    <polygon points='607.4,2.4 555.4,75 607.4,147.5 647.3,147.5 595.3,75 647.3,2.4  ' />
                                    <polygon points='183.7,2.5 151.3,2.5 151.3,147.5 237.6,147.5 237.6,118.6 183.7,118.6  ' />
                                    <path d='M75.3,117.5c-23.5,0-42.5-19-42.5-42.5c0-23.5,19-42.5,42.5-42.5c12.3,0,23.4,5.3,31.2,13.6L130.3,24   C116.6,9.3,97.1,0,75.3,0c-41.4,0-75,33.6-75,75c0,41.4,33.6,75,75,75c21.8,0,41.3-9.3,55-24l-23.8-22.1   C98.7,112.3,87.7,117.5,75.3,117.5z' />
                                    <path d='M489.1,117.5c-23.5,0-42.5-19-42.5-42.5c0-23.5,19-42.5,42.5-42.5c12.3,0,23.4,5.3,31.2,13.6L544.2,24   c-13.7-14.8-33.3-24-55-24c-41.4,0-75,33.6-75,75c0,41.4,33.6,75,75,75c21.8,0,41.3-9.3,55-24l-23.8-22.1   C512.6,112.3,501.5,117.5,489.1,117.5z' />
                                    <polygon points='661.8,2.4 721,147.6 743.6,105.4 701.6,2.4  ' />
                                    <polygon points='738.4,2.4 797.7,147.6 820.3,105.4 778.3,2.4  ' />
                                    <path d='M324.6,0v32.5c23.5,0,42.5,19,42.5,42.5c0,23.5-19,42.5-42.5,42.5c-23.5,0-42.5-19-42.5-42.5h-32.5c0,41.4,33.6,75,75,75   c41.4,0,75-33.6,75-75C399.6,33.6,366,0,324.6,0z' />
                                    <path d='M1106.6,90.4c14.6-7.9,24.5-23.4,24.5-41.2c0-12.9-5.2-24.6-13.7-33.1c-8.5-8.5-20.2-13.7-33.1-13.7h-41.5h-4h-26.7v145.1   h30.6V96h25.7l28.9,51.6l34.9-0.1l-29.8-55.2C1104,91.7,1105.3,91.1,1106.6,90.4z M1042.9,34h42.4c7.9,0,14.3,6.4,14.3,14.3   c0,7.9-6.4,14.3-14.3,14.3h-3c-0.1,0-0.1,0-0.2,0h-39.2V34z' />
                                </g>
                            </svg>
                        </a>
                    </div>

                    <div className={classes.paymentTypes}>
                        <img src={Visa} alt='Parfumer Atelier принимает к оплате карты Visa' />
                        <img
                            src={MasterCard}
                            alt='Parfumer Atelier принимает к оплате карты MasterCard'
                        />
                        <img
                            src={Maestro}
                            alt='Parfumer Atelier принимает к оплате карты Maestro'
                        />
                        <img src={Mir} alt='Parfumer Atelier принимает к оплате карты Мир' />
                    </div>
                    <div className={classes.copyright}>
                        <span>Parfumer Atelier {new Date().getFullYear()}</span>
                    </div>
                </div>
            </footer>
        </>
    )
}

const links = [
    {
        path: '/categories/parfyumeriya',
        name: 'Парфюмерия',
    },
    {
        path: '/categories/aromaboksy',
        name: 'Аромабоксы',
    },
    // {
    //     path: '/brands',
    //     name: 'Бренды',
    // },
    {
        path: '/promo',
        name: 'Акции',
    },
    {
        path: '/contacts',
        name: 'Магазины',
    },
    {
        path: '/franchise',
        name: 'Франшиза',
    },
]

export default Footer
